import React from 'react';

const translations = {
  fr: {
    settings: "Paramètres",
    theme: "Thème :",
    language: "Langue :",
    dark: "Sombre",
    light: "Clair",
    french: "Français",
    english: "Anglais",
    sidebarPosition: "Position barre latérale :",
    left: "Gauche",
    right: "Droite",
    wordWrap: "Retour à la ligne (Éditeur) :",
    on: "Activé",
    off: "Désactivé",
    fontSize: "Taille police (Éditeur) :"
  },
  en: {
    settings: "Settings",
    theme: "Theme:",
    language: "Language:",
    dark: "Dark",
    light: "Light",
    french: "French",
    english: "English",
    sidebarPosition: "Sidebar Position:",
    left: "Left",
    right: "Right",
    wordWrap: "Word Wrap (Editor):",
    on: "On",
    off: "Off",
    fontSize: "Font Size (Editor):"
  }
};

const Settings = ({ currentTheme, setTheme, language, setLanguage, sidebarPosition, setSidebarPosition, wordWrap, setWordWrap, editorFontSize, setEditorFontSize }) => {
  const themes = [
    { name: 'Sombre', value: 'dark' },
    { name: 'Clair', value: 'light' },
  ];

  const languages = [
    { name: 'Français', value: 'fr' },
    { name: 'English', value: 'en' },
  ];

  const t = (key) => translations[language][key] || key;

  return (
    <div className="p-4 bg-[var(--bg-secondary)] text-[var(--text-primary)]">
      <h2 className="text-lg mb-4">{t('settings')}</h2>
      <div className="mb-4">
        <label className="block mb-2">{t('theme')}</label>
        <select
          value={currentTheme}
          onChange={(e) => setTheme(e.target.value)}
          className="bg-[var(--bg-tertiary)] text-[var(--text-primary)] p-2 rounded"
        >
          {themes.map((theme) => (
            <option key={theme.value} value={theme.value}>
              {theme.name}
            </option>
          ))}
        </select>
      </div>
      <div className="mb-4">
        <label className="block mb-2">{t('language')}</label>
        <select
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          className="bg-[var(--bg-tertiary)] text-[var(--text-primary)] p-2 rounded"
        >
          {languages.map((lang) => (
            <option key={lang.value} value={lang.value}>
              {lang.name}
            </option>
          ))}
        </select>
      </div>
      <div className="mb-4">
        <label className="block mb-2">{t('sidebarPosition')}</label>
        <select
          value={sidebarPosition}
          onChange={(e) => setSidebarPosition(e.target.value)}
          className="bg-[var(--bg-tertiary)] text-[var(--text-primary)] p-2 rounded"
        >
          <option value="left">{t('left')}</option>
          <option value="right">{t('right')}</option>
        </select>
      </div>
      <div className="mb-4">
        <label className="block mb-2">{t('wordWrap')}</label>
        <select
          value={wordWrap}
          onChange={(e) => setWordWrap(e.target.value)}
          className="bg-[var(--bg-tertiary)] text-[var(--text-primary)] p-2 rounded"
        >
          <option value="on">{t('on')}</option>
          <option value="off">{t('off')}</option>
        </select>
      </div>
      <div className="mb-4 flex flex-col items-start">
        <label className="block mb-2">{t('fontSize')}</label>
        <input
          type="number"
          value={editorFontSize}
          onChange={(e) => setEditorFontSize(Number(e.target.value))}
          className="bg-[var(--bg-tertiary)] text-[var(--text-primary)] p-2 rounded w-24 outline-none border border-[#2b2b2b] focus:border-[#007acc]"
          min="8"
          max="32"
        />
      </div>
    </div>
  );
};

export default Settings;
